<template>
	<div class="view-portfolio" ng-if="data && data.length">
		<ul class="portfolio-list clearfix">
			<li class="item" v-for="item in paginate(data)" :id="item.name">
				<img :src="item.image" class="item-img"/>
				<div class="item-data">
					<h4 class="item-caption">{{item.caption}}</h4>
					<div class="item-desc">{{item.desc}}</div>
					<a v-if="item.link" :href="item.link" target="_blank" class="item-desc">
						{{item.linkCaption || 'Open in new window'}} <span class="glyphicon glyphicon-new-window"></span>
					</a>
				</div>
			</li>
		</ul>
		<nav aria-label="Page navigation">
			<ul class="pagination">
				<li><a @click="setPage(currentPage-1)" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
				<li v-for="pageNumber in totalPages">
					<a @click="setPage(pageNumber-1)" :class="{current: currentPage === pageNumber-1}">{{ pageNumber }}</a>
				</li>
				<li><a @click="setPage(currentPage+1)" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>
			</ul>
		</nav>
	</div>
</template>

<script>
	export default {
		name: 'viewPorfolio',
		props: ['data', 'itemsPerPage'],
		computed: {
			totalPages () {
				return Math.ceil(this.resultCount / this.itemsPerPage)
			}
		},
		methods: {
			setPage (pageNumber) {
				if (pageNumber >= 0 && pageNumber <= this.totalPages) {
					this.currentPage = pageNumber
				}
			},
			paginate (list) {
				this.resultCount = list.length;
				if (this.currentPage >= this.totalPages) {
					this.currentPage = this.totalPages - 1
				}
				let index = this.currentPage * this.itemsPerPage;
				return list.slice(index, index + this.itemsPerPage)
			}
		},
		data () {
			return {
				currentPage: 0,
				resultCount: 0
			}
		}
	}
</script>

<style scoped>
	.portfolio-list { list-style: none; margin:0; padding:0; }
	.portfolio-list .item { position:relative; float:left; width:calc(25% - 15px); margin:0 15px 15px 0; background:#e5e5e5; overflow:hidden; }
	.portfolio-list .item .item-img { width:100%; padding:0; border:2px solid #ccc; }
	.portfolio-list .item .item-data { transform: translateY(50%); filter:opacity(0); transition: 0.7s; position:absolute; width:calc(100% - 2px); min-height:0; left:1px; bottom:1px; padding:10px;
									   white-space: nowrap;  text-overflow: ellipsis;  overflow: hidden; background: rgba(220,220,220,0.90); }
	.portfolio-list .item .item-data .item-caption { margin:0 0 5px; font-size:14px; font-weight:600; }
	.portfolio-list .item .item-data .item-desc { font-size:14px; font-weight:200; margin-bottom:5px; }
	.portfolio-list .item:hover .item-data { transform: translateY(0);filter:opacity(1); min-height:90px; max-height:150px;  }
	.pagination { margin:20px 0 0; }
	.pagination li a { border-color:#ccc; cursor: pointer; }

	@media (max-width: 1200px){
		.portfolio-list .item { width:calc(33% - 20px); }
	}

	@media (max-width: 768px){
		.portfolio-list .item .item-data .item-caption { font-size:12px; }
		.portfolio-list .item .item-data .item-desc { font-size:12px; }
	}

	@media (max-width: 640px){
		.portfolio-list .item { width:calc(50% - 20px); }
	}
</style>



// WEBPACK FOOTER //
// viewPortfolio.vue?31f37777